<footer>
  <div class="footer-container">
    <div class="v1"></div>
    <div class="v2"></div>
    <div class="v3"></div>
    <div class="v4"></div>
    <h5 style="font-weight: normal;">¿No encuentras un paquete para ti?</h5>
    <h2 style="font-weight: bold;">Contáctanos</h2>
    <div class="footer-text">¿Quieres ofrecer a tus pacientes una experiencia de vanguardia y alta tecnología pero no encuentras la opción adecuada para ti? Nosotros construimos un paquete pensado para tus necesidades.</div>
    <div class="myicons">
      <img class="myicon" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/whatsappicon.png" alt="">
      <img class="myicon" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/emailicon.png" alt="">
    </div>
  </div>
</footer>
